import { RefObject, useEffect, useState } from 'react';

import isNode from 'detect-node';

export enum OverflowDirection {
  X = 'X',
  Y = 'Y',
  EITHER = 'EITHER',
}

export function useElementIsOverflowing(
  elementRef: RefObject<HTMLDivElement | null> | null,
  direction: OverflowDirection,
  deps: any[] = [],
  correctionFactor = 0,
): boolean {
  const [state, setState] = useState<boolean>(false);

  useEffect(() => {
    const element = elementRef ? elementRef.current : null;
    if (isNode || !element) {
      return;
    }

    const measure = () => {
      if (direction === OverflowDirection.X || direction === OverflowDirection.EITHER) {
        setState(element.scrollWidth > element.offsetWidth);
      } else {
        setState(element.scrollHeight > element.offsetHeight + correctionFactor);
      }
    };

    measure();

    if (typeof ResizeObserver === 'undefined') {
      return;
    }
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementRef, direction, ...deps]);

  return state;
}
